import { differenceInMinutes } from 'date-fns';

export const getColor = (status: string, hospitalId?: number, defaultColor: string | null = '#00A7F7') => {
  const applyColor =
    (window.location.hostname === 'localhost' && hospitalId === 10) ||
    (window.location.hostname === 'testing.ospitek.com' && hospitalId === 10) ||
    (window.location.hostname === 'testing.ospitek.com' && hospitalId === 138) ||
    (window.location.hostname === 'view3.ospitek.com' && hospitalId === 3) ||
    (window.location.hostname === 'view3.ospitek.com' && hospitalId === 10) ||
    (window.location.hostname === 'view4.ospitek.com' && hospitalId === 2) ||
    (window.location.hostname === 'view4.ospitek.com' && hospitalId === 10) ||
    (window.location.hostname === 'view4.ospitek.com' && hospitalId === 16) ||
    (window.location.hostname === 'view4.ospitek.com' && hospitalId === 22) ||
    (window.location.hostname === 'view5.ospitek.com' && hospitalId === 13) ||
    (window.location.hostname === 'view5.ospitek.com' && hospitalId === 14); 

  const applyCustomColors =
    (window.location.hostname === 'view5.ospitek.com' && hospitalId === 6) ||
    (window.location.hostname === 'view5.ospitek.com' && hospitalId === 7) ||
    (window.location.hostname === 'view5.ospitek.com' && hospitalId === 8) ||
    (window.location.hostname === 'testing.ospitek.com' && hospitalId === 158);

  const applyView4Hospital15Colors =
    (window.location.hostname === 'view4.ospitek.com' && hospitalId === 15) ||
    (window.location.hostname === 'testing.ospitek.com' && hospitalId === 171);

  if (applyView4Hospital15Colors) {
    switch (status) {
      case 'WR':
      case 'Admitted':
        return '#A020F0';
      case 'PRE-OP':
        return '#0047AB';
      case 'OR':
      case 'InOr':
      case 'AnestStart':
      case 'PhysIn':
      case 'TimeOut':
      case 'AntibioticTime':
      case 'Ready':
      case 'Ongoing':
        return '#00FF00';
      case 'PACU':
      case 'Closing':
      case 'SurgeonLeft':
      case 'SurgeonLeftOR':
      case 'End':
      case 'ProcedureEnd':
      case 'AnestEnd':
        return '#ffbf00';
      default:
        return defaultColor;
    }
  }

  if (applyCustomColors) {
    switch (status) {
      case 'WR':
        return '#ffbf00';
      case 'PRE-OP':
        return '#00FF00';
      case 'OR':
      case 'InOr':
      case 'AnestStart':
      case 'PhysIn':
      case 'TimeOut':
      case 'AntibioticTime':
      case 'Ready':
      case 'Ongoing':
      case 'SurgeonLeft':
      case 'SurgeonLeftOR':
        return '#F55323';
      case 'Closing':
      case 'End':
      case 'AnestEnd':
        return '#FF2C2C';
      default:
        return defaultColor;
    }
  }

  if (applyColor) {
    const view3Org3 =
      (window.location.hostname === 'view3.ospitek.com' && hospitalId === 3) ||
      (window.location.hostname === 'testing.ospitek.com' && hospitalId === 138);

    switch (status) {
      case 'WR':
        return '#8a5117';
      case 'PRE-OP':
        return 'rgb(255, 142, 161, 75%)';
      case 'OR':
        return '#0047AB';
      case 'AnestStart':
      case 'PhysIn':
      case 'TimeOut':
      case 'AntibioticTime':
      case 'Ready':
      case 'Ongoing':
        return '#00FF00';
      case 'CallNextPatient':
        return '#00FF00';
      case 'Closing':
        return '#ffbf00';
      case 'SurgeonLeft':
      case 'SurgeonLeftOR':
        return '#ffbf00';
      case 'Dressing':
        return '#A020F0';
      case 'End':
      case 'AnestEnd':
        return view3Org3 ? '#A020F0' : '#F55323';
      default:
        return defaultColor;
    }
  }

  return defaultColor;
};

export const getRelativeDuration = (dayStart: Date, duration: number, dayEnd: Date) => {
  if (duration) {
    return (duration * 100) / differenceInMinutes(dayEnd, dayStart);
  } else {
    return 10;
  }
};
